<template>
  <TrackContextMenu v-if="rightClickedTrack" :key="rightClickedTrack.id" ref="menu" :track="rightClickedTrack" :playlist-context="false" :extras="extraContextMenuItem" @action="perform" @close="closeMenu" />
</template>
<script>
import TrackList from '../components/TrackList.vue';
// The home hero uses the existing track action controller without rendering a
// second, hidden song list. Queue, download, favorite and share stay shared.
export default { name: 'AppleTrackActions', extends: TrackList };
</script>
